import styled, { css } from 'styled-components';
import { Modal, Stack } from 'src/components';
import { rtlFlip } from 'src/utils/theme';
import { transparentize } from 'polished';

export const ModalWrapper = styled(Modal)(
  ({ theme }) => css`
    .reactModalContent {
      max-width: ${theme.sz.lg};
    }

    @media (min-height: ${theme.sz.ms}) {
      .reactModalOverlay {
        align-items: flex-end;
        padding: 0;
      }

      .reactModalContent {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        overflow: hidden;
        margin: 0;
      }
    }
  `,
);

export const Content = styled(Stack)(
  ({ theme }) => css`
    background: ${theme.co.secondary20};
    padding: ${theme.sz.s8} ${theme.sz.s10};
  `,
);

export const Image = styled.img(
  ({ theme }) => css`
    position: absolute;
    width: ${theme.sz.s28};
    height: ${theme.sz.s28};
    inset: 0;
    z-index: ${theme.zi.z1};

    @media (max-width: ${theme.sz.md}) {
      width: ${theme.sz.s24};
      height: ${theme.sz.s24};
    }
  `,
);

export const ImageWrapper = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.s28};
    height: ${theme.sz.s28};
    position: relative;
    margin-top: ${theme.sz.s4};

    @media (max-width: ${theme.sz.md}) {
      width: ${theme.sz.s24};
      height: ${theme.sz.s24};
    }
  `,
);

export const ImageCircle = styled.div<{ $color: string }>(
  ({ theme, $color }) => css`
    width: ${theme.sz.s28};
    height: ${theme.sz.s28};
    background-color: ${$color};
    box-shadow: 0 ${theme.sz.s1} ${theme.sz.s1} 0 ${transparentize(0.75, theme.co.neutral0)};
    border-radius: ${theme.bo.round};
    position: absolute;
    inset: 0;

    @media (max-width: ${theme.sz.md}) {
      width: ${theme.sz.s24};
      height: ${theme.sz.s24};
    }
  `,
);

export const StarsContainer = styled.div(
  ({ theme }) => css`
    position: absolute;
    top: -${theme.sz.s8};
    right: -${theme.sz.s8};
    transform: scaleX(${rtlFlip(theme)}) rotate(-10deg);
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    color: ${theme.co.primary99};
    text-align: center;
    ${theme.typography.heading.desktop.l};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.l};
    }
  `,
);

export const Description = styled.span(
  ({ theme }) => css`
    color: ${theme.co.primary99};
    text-align: center;
    ${theme.typography.paragraph.l};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.base};
    }
  `,
);

export const Actions = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.sz.s4};
    align-self: stretch;

    > * {
      flex-basis: 50%;
    }

    @media (max-width: ${theme.sz.md}) {
      flex-wrap: wrap;

      > * {
        flex-basis: 100%;
      }
    }
  `,
);
